<template class="full-height">
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="app-container" style="position: relative; height: 100%; padding: 15px">
    <member-data />
  </div>
</template>

<script>
export default {
  name: 'AgencyMember',
  components: {
    memberData: () => import('@/views/ita/agency/agencyMember/components/agencyMemberList.vue'),
  },
  data() {
    return {
      list: null,
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {},
    handleDownload() {},
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}
</style>
